import { getDefaultExerciseVersion } from '../../config';
import {
  AudioSoundEvent,
  CustomIconName,
  Exercise,
  Level,
  Phase,
  ScheduleEntryColourCode,
  SessionSequence,
  UserExerciseSession,
  WorkoutSettings,
} from '../../entities';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';

export class BalanceFlashCombo implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAlernativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
    level?: Level,
    workoutSettings?: WorkoutSettings,
    previousExerciseSessions?: UserExerciseSession[],
    exerciseFormatDescription?: string,
    loop?: number,
  ): SessionSequence[] {
    const isRepeatingExercise =
      exercise.uniqueReferenceNumber ===
      alernativeExercise.uniqueReferenceNumber;
    return [
      {
        durationInMilliseconds: 20,
        sequence: [
          {
            durationInMilliseconds: 20,
            videoFile: exercise.uniqueReferenceNumber,
            exerciseVersion: exercise._rev,
            displayName: exercise.name,
            displayBurnOrBuildIcon: true,
            customIcon: isRepeatingExercise
              ? CustomIconName.RepeatAndBalance
              : undefined,
            progressColourCode: ScheduleEntryColourCode.Rest,
            progressText: 'Start in {seconds}',
            showProcessedMetrics: false,
            showCalculatedMetrics: true,
            audioSoundEvent: undefined,
            tips: Exercise.getFormattedTips(exercise),
            phase: Phase.Rest,
            zone,
            equipmentWeightInfo: exercise.equipmentWeightInfo,
          },
        ],
      },
      {
        durationInMilliseconds: 40,
        sequence: [
          {
            durationInMilliseconds: 40,
            videoFile: exercise.uniqueReferenceNumber,
            exerciseVersion: exercise._rev,
            displayName: exercise.name,
            displayBurnOrBuildIcon: true,
            customIcon: isRepeatingExercise
              ? CustomIconName.RepeatAndBalance
              : undefined,
            progressColourCode: ScheduleEntryColourCode.Play,
            progressText: 'Train for {seconds}',
            showProcessedMetrics: false,
            showCalculatedMetrics: true,
            audioSoundEvent: AudioSoundEvent.startOfWorkout,
            tips: Exercise.getFormattedTips(exercise),
            phase: Phase.Train,
            equipmentWeightInfo: exercise.equipmentWeightInfo,
            zone,
          },
        ],
      },
      {
        durationInMilliseconds: 16,
        sequence: [
          {
            durationInMilliseconds: 16,
            videoFile: alernativeExercise.uniqueReferenceNumber,
            exerciseVersion: alernativeExercise._rev,
            displayName: alernativeExercise.name,
            displayBurnOrBuildIcon: true,
            customIcon: isRepeatingExercise ? CustomIconName.Repeat : undefined,
            progressColourCode: ScheduleEntryColourCode.Rest,
            progressText: isRepeatingExercise
              ? 'Rest & Repeat in {seconds}'
              : 'Start in {seconds}',
            showProcessedMetrics: false,
            showCalculatedMetrics: true,
            audioSoundEvent: AudioSoundEvent.startOfRestPeriod,
            tips: Exercise.getFormattedTips(alernativeExercise),
            phase: Phase.Rest,
            zone,
            equipmentWeightInfo: alernativeExercise.equipmentWeightInfo,
          },
        ],
      },
      {
        durationInMilliseconds: 40,
        sequence: [
          {
            durationInMilliseconds: 40,
            videoFile: alernativeExercise.uniqueReferenceNumber,
            exerciseVersion: alernativeExercise._rev,
            displayName: alernativeExercise.name,
            displayBurnOrBuildIcon: true,
            progressColourCode: ScheduleEntryColourCode.Play,
            progressText: 'Train for {seconds}',
            showProcessedMetrics: false,
            showCalculatedMetrics: true,
            audioSoundEvent: AudioSoundEvent.startOfWorkout,
            tips: Exercise.getFormattedTips(alernativeExercise),
            phase: Phase.Train,
            equipmentWeightInfo: exercise.equipmentWeightInfo,
            zone,
          },
        ],
      },
      {
        durationInMilliseconds: 4,
        sequence: [
          {
            durationInMilliseconds: 4,
            videoFile: SessionSequence.changeZonesVideo(),
            exerciseVersion: getDefaultExerciseVersion(),
            displayName: exercise.name,
            displayBurnOrBuildIcon: false,
            progressColourCode: ScheduleEntryColourCode.Rest,
            progressText: 'Move to zone {zoneNumber} now',
            showProcessedMetrics: false,
            showCalculatedMetrics: true,
            audioSoundEvent: AudioSoundEvent.endOfWorkoutSession,
            tips: Exercise.getFormattedTips(exercise),
            phase: Phase.Rest,
            zone,
          },
        ],
      },
    ];
  }
}
